// extracted by mini-css-extract-plugin
export default {"statusIcon":"statusIcon__wkEME","error":"error__noRbU","success":"success__UqnTb","contactAdmin":"contactAdmin__rAHwU"};